import { render, staticRenderFns } from "./InclusiveSustainability.vue?vue&type=template&id=9daab948&scoped=true&"
import script from "./InclusiveSustainability.vue?vue&type=script&lang=js&"
export * from "./InclusiveSustainability.vue?vue&type=script&lang=js&"
import style0 from "./InclusiveSustainability.vue?vue&type=style&index=0&id=9daab948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9daab948",
  null
  
)

export default component.exports